import http from "@/http/aisea/axios";
const resource = "/hull_insurance/enterprises/claim_reports";

export default {
  fetch(claimReportId) {
    return http.get(`${resource}/${claimReportId}/staffs`);
  },
  add(claimReportId, body) {
    return http.post(`${resource}/${claimReportId}/staffs`, body);
  },
  delete(claimReportId, staffId) {
    return http.delete(`${resource}/${claimReportId}/staffs/${staffId}`);
  },
  update(claimReportId, staffId, body) {
    return http.put(`${resource}/${claimReportId}/staffs/${staffId}`, body);
  },
};
